import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../utils/firebase";
import { useAuth } from "../../state/AuthContext";

export default function EmployeeHeader() {
  const { user, logout } = useAuth();
  const email = user?.email || localStorage.getItem("user");
  const [employeeName, setEmployeeName] = useState("");

  useEffect(() => {
    const fetchEmployeeName = async () => {
      if (!email) return;
      try {
        const docRef = doc(db, "userDetails", email);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setEmployeeName(docSnap.data().username || email.split("@")[0]);
        } else {
          setEmployeeName(email.split("@")[0]);
        }
      } catch (err) {
        console.error("Error fetching employee name:", err);
        setEmployeeName(email.split("@")[0]);
      }
    };

    fetchEmployeeName();
  }, [email]);

  const demoLink =
    "https://drive.google.com/file/d/1kjNGcUNQ6wgz7O8KjudlUDLaaWroYP7h/view?usp=drive_link";

  return (
    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center bg-white shadow p-4 border-l-4 border-[#6cbb23] gap-3">
      <div>
        <h1 className="text-xl sm:text-2xl font-bold text-gray-800">
          Welcome, <span className="text-[#6cbb23]">{employeeName}</span>
        </h1>
        <p className="text-sm text-gray-500">Employee Dashboard</p>
      </div>

      <div className="flex gap-3 w-full sm:w-auto">
        {/* Watch Demo */}
        <button
          onClick={() => window.open(demoLink, "_blank")}
          className="w-full sm:w-auto px-4 py-2 bg-[#6cbb23] text-white rounded shadow hover:bg-[#5da71e] transition"
        >
          Watch Demo
        </button>

        {/* Logout */}
        <button
          onClick={() => logout(() => {})}
          className="w-full sm:w-auto px-4 py-2 bg-red-500 text-white rounded shadow hover:bg-red-600 transition"
        >
          Logout
        </button>
      </div>
    </div>
  );
}
